export default __webpack_public_path__ + "static/1772-7fa55a3155a27b02c186366a617d84d6.gif";